<template>
  <page-base
    ref="page"
    id="page"
    v-model="modules"
    :type="type"
    @clickItem="clickItem"
    @updateTops="updateTops"
    @updateModules="updateModules"
    :currentIndex="currentIndex"
  />
</template>

<script>
let origin = process.env.NODE_ENV === "development" ? "*" : "http://wx.zhifu88.cn/";
import navList from "./navList";
import moduleSetting from "./moduleSetting";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      type: "edit",
      currentIndex: -1,
      modules: [],
      dataurl: "",
      height: 0,
    };
  },
  created() {},
  mounted() {
    window.addEventListener("message", this.listener, false);
    this.updateNavList(navList);
    this.updateModuleSetting(moduleSetting);
  },
  destroyed() {
    window.removeEventListener("message", this.listener);
  },
  methods: {
    getImage() {
      let that = this;
      let page = document.getElementById("page");

      html2canvas(page, {
        useCORS: true,
        height: this.height,
      }).then(function (canvas) {
        var blob = that.getBlob(canvas);
        blob.lastModifiedDate = new Date();
        let fileName = new Date().getTime() + ".jpg";
        blob.name = fileName;
        that.$http.wxUpload(blob, fileName).then((res) => {
          that.sendImgage(res.data);
        });
        // var oMyForm = new FormData();
        // var fileName = "mobile" + '.jpg'
        // oMyForm.append("file", blob, fileName);
        // //              oMyForm.append("fileName", fileName);
        // oMyForm.append("fileType", 'image');
        // oMyForm.append("user_id", that)
      });
    },
    getBlob(canvas) {
      //获取blob对象
      var data = canvas.toDataURL("image/jpeg", 1);
      data = data.split(",")[1];
      data = window.atob(data);
      var ia = new Uint8Array(data.length);
      for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      }
      return new Blob([ia], {
        type: "image/jpeg",
      });
    },
    listener(e) {
      //判断来源
      let Obj = {};
      try {
        Obj = JSON.parse(e.data);
      } catch (e) {
        console.error(e);
      }

      let { data, type } = Obj;
      console.log("mobile onmessage", type, data);

      //事件分配
      switch (type) {
        case "updateModules":
          this.onUpdateModules(data);
          break;
        case "updateSelectEdIndex":
          this.onUpdateSelectEdIndex(data);
          break;
        case "updateThemeFontColor":
          this.onUpdateThemeFontColor(data);
          break;
        case "getImage":
          this.currentIndex = -1;
          setTimeout(() => {
            this.getImage(data);
          }, 300);
          break;
      }
    },
    postMessage(type, data) {
      console.log("mobile postMessage", type, data);
      parent.postMessage(JSON.stringify({ type, data }), "*");
    },
    clickItem(top, item, index) {
      this.postMessage("clickItem", { top, item, index });
    },
    updateTops(tops) {
      this.postMessage("updateTops", tops);
    },
    updateNavList(navList) {
      this.postMessage("updateNavList", navList);
    },
    updateModules(modules) {
      this.postMessage("updateModules", modules);
    },
    updateModuleSetting(moduleSetting) {
      this.postMessage("updateModuleSetting", moduleSetting);
    },
    sendImgage(imageUrl) {
      this.postMessage("onGetImage", imageUrl);
    },
    onUpdateModules(modules) {
      console.log("onUpdateModules", modules);
      this.modules = modules;
    },
    onUpdateSelectEdIndex(index) {
      this.currentIndex = index;
    },
    onUpdateThemeFontColor(color) {
      window.document.body.style.setProperty("--theme-font-color", color);
    },
  },
  watch: {
    modules: {
      deep: true,
      handler: function (newVal) {
        this.modules = newVal;
        let that = this;
        const updateHeight = function () {
          that.height = document.getElementById("page").scrollHeight;
          that.postMessage("updateHeight", that.height);
        };
        that.$nextTick(() => {
          updateHeight();
          setTimeout(() => {
            updateHeight();
          }, 300);
          setTimeout(() => {
            updateHeight();
          }, 600);
        });

        // setTimeout(() => {
        //   updateHeight()
        // }, 600)
      },
    },
    currentIndex: function (val) {
      let that = this;
      that.$nextTick(() => {
        let height = document.body.scrollHeight;
        that.postMessage("updateHeight", height);
      });
    },
  },
};
</script>
